import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: auto;
	min-height: 50vh;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 32px;
	margin-top: 32px;
	margin-bottom: 8px;
`;

const p = styled.p`
	font-weight: normal;
	font-size: 17px;
	margin: 0;
	margin-bottom: 32px;
`;

const RollerShutterSpraying = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Roller Shutter Spraying</Title>
			<p>
				Advanced spray decorators can recolour or refresh roller shutters to
				shop fronts and large commercial and industrial buildings either
				carrying out minor dent repairs or small corrosion repairs to the
				shutters.
				<br />
				<br />
				We can work with small private shop keepers to national large retailers
				throughout the UK. If your roller shutters are looking weathered and
				discoloured and are in need of a refresh or if they have been damaged
				and need respraying advanced spray decorators can carry this kind of
				work out for you in or out of hours to suit.
				<br />
				<br />
				Are you rebranding? We can help recolour your roller shutters internally
				and externally. Choose from a large selection of RAL codes or we can
				colour match to any other colour you like.
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default RollerShutterSpraying;



// WEBPACK FOOTER //
// ./src/components/page/roller-shutter-spraying.js